/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable max-len */
import { useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';

import useStyles from './style';
import { Typography } from '@material-ui/core';
import {
  getFromLS,
  publicImgMajorTest,
  publicSvgPath,
  resultatWithColor,
} from '@orientaction/utils';
import dateFormat from 'dateformat';
import { getUserById } from '../../../../services/user.service';
import Podium from '../FirstView/Podium';
import { appLanguage } from '@orientaction/reducers';
import { useSelector } from 'react-redux';
import { concat } from 'lodash';

export interface ResultatPDFHandle {
  handleDownload: () => Promise<void>;
}

const ResultatPDF = forwardRef<ResultatPDFHandle, { myResult: any; idResult: number }>(
  ({ myResult, idResult }, ref) => {
    const classes = useStyles({});
    const headerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const { users_permissions_user, resultat, listHistory } = myResult;
    const token = getFromLS('userToken') || '';
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [date, setDate] = useState<string>('');
    const lang: string = useSelector(appLanguage);
    useEffect(() => {
      const getUser = () => {
        setLoading(true);
        if (token && users_permissions_user) {
          getUserById({ token, userId: users_permissions_user })
            .then((res: any) => {
              setUser(res?.data ?? {});
              return 'ok';
            })
            .then(() => {
              setLoading(false);
            });
        }
      };
      getUser();
    }, [users_permissions_user, token]);

    useEffect(() => {
      setDate(listHistory?.find((item: any) => item.id === idResult)?.createdAt);
    }, [listHistory, idResult]);

    const handleDownload = async () => {
      if (!headerRef.current || !contentRef.current) {
        return;
      }

      const { default: html2pdf } = await import('html2pdf.js');

      // Options pour le premier PDF (header sans margin)
      const headerOptions = {
        margin: [0, 0, 0, 0], // Pas de margin pour le header
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#FFF',
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Format A4 en pixels à ~150 DPI : 1240px × 1754px (210mm × 297mm)
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          after: '.page-break-after',
        },
      } as any;

      // Options pour le second PDF (contenu avec margin)
      const contentOptions = {
        margin: [80, 0, 80, 0], // Margin global pour le contenu
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true,
          backgroundColor: '#F7F7FB',
          removeContainer: true,
          allowTaint: true,
        },
        jsPDF: {
          unit: 'px',
          // Même format que le header pour garder un rendu homogène
          format: [1240, 1754],
          orientation: 'portrait',
          compress: true,
        },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: '.page-break-before',
          after: '.page-break-after',
        },
      } as any;

      try {
        // Générer le premier PDF (header) en mémoire
        const headerPdfBlob = await html2pdf()
          .set(headerOptions)
          .from(headerRef.current)
          .output('blob');

        // Générer le second PDF (contenu) en mémoire
        const contentPdfBlob = await html2pdf()
          .set(contentOptions)
          .from(contentRef.current)
          .output('blob');

        // Convertir les blobs en ArrayBuffers
        const headerArrayBuffer = await headerPdfBlob.arrayBuffer();
        const contentArrayBuffer = await contentPdfBlob.arrayBuffer();

        // Utiliser pdf-lib pour fusionner les PDFs
        const { PDFDocument } = await import('pdf-lib');

        // Créer un nouveau document PDF
        const mergedPdf = await PDFDocument.create();

        // Charger les deux PDFs
        const headerPdfDoc = await PDFDocument.load(headerArrayBuffer);
        const contentPdfDoc = await PDFDocument.load(contentArrayBuffer);

        // Copier toutes les pages du header PDF
        const headerPages = await mergedPdf.copyPages(headerPdfDoc, headerPdfDoc.getPageIndices());
        headerPages.forEach((page: any) => mergedPdf.addPage(page));

        // Copier toutes les pages du content PDF
        const contentPages = await mergedPdf.copyPages(
          contentPdfDoc,
          contentPdfDoc.getPageIndices()
        );
        contentPages.forEach((page: any) => mergedPdf.addPage(page));

        // Sauvegarder le PDF fusionné
        const mergedPdfBytes = await mergedPdf.save();
        const uint8Array = new Uint8Array(mergedPdfBytes);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Résultat Sens® test des 10 valeurs - ${user?.firstname || ''} ${user?.lastname || ''}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erreur lors de la génération du PDF:', error);
      }
    };

    useImperativeHandle(ref, () => ({
      handleDownload,
    }));

    const getImg = (key: string): string => {
      switch (key) {
        case 'compliance':
          return 'en_compliance.png';

        case 'universalism':
          return 'en_UNIVERSALISME_carte.png';

        case 'hedonism':
          return 'en_HEDONISME_carte.png';

        case 'achievement':
          return 'en_REUSSITE_carte.png';

        case 'stimulation':
          return 'en_STIMULATION_carte.png';

        case 'tradition':
          return 'en_TRADITION_carte.png';

        case 'kindness':
          return 'en_BIENVEILLANCE_carte.png';

        case 'security':
          return 'en_SECURITE_carte.png';

        case 'power':
          return 'en_POUVOIR_carte.png';

        case 'autonomy':
          return 'en_AUTONOMIE_carte.png';
        default:
          return '';
      }
    };

    return (
      <>
        {!loading && resultat && (
          <div className={classes.wrapper}>
            {/* Premier export PDF - Header sans margin */}
            <div ref={headerRef} className={classes.page}>
              <div id="ma-banniere-pdf" className={`${classes.header}`}>
                <Typography variant="h2" className={classes.titleHeader} style={{ margin: 0 }}>
                  Sens®, <br />
                  test des 10 valeurs
                </Typography>
              </div>
              <div className="page-break-after" style={{ padding: '80px 80px 0px 80px' }}>
                <div className={classes.imgBanner}>
                  <img
                    src={`${publicImgMajorTest}/illustration_banniere.png`}
                    alt="couverture intro"
                  />
                </div>
                <div className={classes.info}>
                  <div className={classes.infoContent}>
                    Nom du test : <span>Sens®, test des 10 valeurs</span>
                  </div>
                  <div className={classes.infoContent}>
                    Bénéficiaire :{' '}
                    <span>
                      {user?.firstname} {user?.lastname}
                    </span>
                  </div>
                  <div className={classes.infoContent}>
                    Date de passation :{' '}
                    <span>{date && dateFormat(new Date(date), 'dd/mm/yyyy')}</span>
                  </div>
                  <div className={classes.infoContent}>
                    Consultant :{' '}
                    <span>
                      {user?.upper_hierarchy?.firstname} {user?.upper_hierarchy?.lastname}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Second export PDF - Contenu avec margin */}
            <div ref={contentRef} className={classes.page}>
              <div style={{ padding: '0px 80px 0px 80px' }}>
                <div className={`${classes.section}`}>
                  <h2 className={`${classes.heading} ${classes.h1}`} style={{ marginTop: 0 }}>
                    Découvrez vos valeurs
                  </h2>
                  <p className={classes.paragraph} style={{ fontSize: 24, fontWeight: 700 }}>
                    Voici vos valeurs directrices. Vos valeurs directrices guident vos pensées et
                    vos comportements. Elles sont à la source du sens que vous donnez à vos actions.
                    Agir conformément à vos valeurs vous permettra de développer votre motivation et
                    votre bien-être. Vous vous sentirez aligné(e) entre ce que vous êtes et ce que
                    vous faites.
                  </p>
                  <div className={classes.sliderScore}>
                    <div className={classes.sliderScoreItem}>
                      <Podium first={resultat[0]} second={resultat[1]} third={resultat[2]} useForPDF={true} />
                    </div>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h4}`} style={{ marginTop: 30 }}>
                    Application dans votre vie pro et personnelle
                  </h2>
                  <p className={classes.paragraph}>
                    Dans votre vie professionnelle, vous devriez exercer un métier cohérent avec vos
                    valeurs et travailler dans une organisation qui vous permet de les exprimer à
                    travers vos actions. Dans votre vie personnelle, vous devriez développer des
                    relations avec des personnes qui partagent vos valeurs. Développer des relations
                    avec des personnes qui ont la même vision de la vie que vous favorise la bonne
                    entente et l’harmonie.
                  </p>
                </div>
                <div className={`${classes.section} page-break-before`} style={{ paddingTop: 0 }}>
                  <div className={classes.score}>
                    {resultat[0]?.label}
                    <span>{resultat[0]?.score}</span>
                    <span>/100</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    {resultat[0]?.description[0]}
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html: resultatWithColor[resultat[0]?.key].longText,
                    }}
                  />
                  <div className={`${classes.imgWhiteBanner} page-break-after`} style={{ marginBottom: '0px' }}>
                    <img
                      src={`${publicSvgPath}/${
                        lang !== 'FR'
                          ? getImg(resultat[0]?.key)
                          : resultatWithColor[resultat[0]?.key].img
                      }`}
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h3}`} style={{ marginTop: 0 }}>{resultat[0]?.label}</h2>
                  <h2 className={`${classes.heading} ${classes.h5}`} style={{ marginTop: 20 }}>
                    Les conseils de carrière d'Orientaction
                  </h2>
                  <p
                    className={classes.paragraph}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[0]?.key].text1 }}
                    style={{ marginBottom: '50px' }}
                  />
                  {resultatWithColor[resultat[0]?.key].listeAccordeon.map((item: any) => (
                    <div key={item.title} style={{ marginBottom: '60px' }}>
                      <h2 className={`${classes.heading} ${classes.h6}`}>{item.title}</h2>
                      <p
                        className={classes.paragraph}
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      />
                    </div>
                  ))}

                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[0]?.key].text2 }}
                  />

                  <h2 className={`${classes.heading} ${classes.h5}`} style={{ marginTop: 120, marginBottom: '20px' }}>
                    Liste des métiers en lien avec cette valeur
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginBottom: '50px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[0]?.key].text3 }}
                  />
                  <ul className={classes.listUl}>
                    {concat(
                      resultatWithColor[resultat[0]?.key].listEmploi1,
                      resultatWithColor[resultat[0]?.key].listEmploi2
                    ).map((item: any) => (
                      <li className={classes.listLi} key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginTop: '45px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[0]?.key].text4 }}
                  />
                </div>

                <div className={`${classes.section} page-break-before`} style={{ paddingTop: 0 }}>
                  <div className={classes.score}>
                    {resultat[1]?.label}
                    <span>{resultat[1]?.score}</span>
                    <span>/100</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    {resultat[1]?.description[0]}
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html: resultatWithColor[resultat[1]?.key].longText,
                    }}
                  />
                  <div className={`${classes.imgWhiteBanner} page-break-after`} style={{ marginBottom: '0px' }}>
                    <img
                      src={`${publicSvgPath}/${
                        lang !== 'FR'
                          ? getImg(resultat[1]?.key)
                          : resultatWithColor[resultat[1]?.key].img
                      }`}
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h3}`} style={{ marginTop: 0 }}>{resultat[1]?.label}</h2>
                  <h2 className={`${classes.heading} ${classes.h5}`} style={{ marginTop: 20 }}>
                    Les conseils de carrière d'Orientaction
                  </h2>
                  <p
                    className={classes.paragraph}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[1]?.key].text1 }}
                    style={{ marginBottom: '50px' }}
                  />
                  {resultatWithColor[resultat[1]?.key].listeAccordeon.map((item: any) => (
                    <div key={item.title} style={{ marginBottom: '60px' }}>
                      <h2 className={`${classes.heading} ${classes.h6}`}>{item.title}</h2>
                      <p
                        className={classes.paragraph}
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      />
                    </div>
                  ))}

                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[1]?.key].text2 }}
                  />

                  <h2 className={`${classes.heading} ${classes.h5}`} style={{ marginTop: 120, marginBottom: '20px' }}>
                    Liste des métiers en lien avec cette valeur
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginBottom: '50px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[1]?.key].text3 }}
                  />
                  <ul className={classes.listUl}>
                    {concat(
                      resultatWithColor[resultat[1]?.key].listEmploi1,
                      resultatWithColor[resultat[1]?.key].listEmploi2
                    ).map((item: any) => (
                      <li className={classes.listLi} key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginTop: '45px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[1]?.key].text4 }}
                  />
                </div>

                <div className={`${classes.section} page-break-before`} style={{ paddingTop: 0 }}>
                  <div className={classes.score}>
                    {resultat[2]?.label}
                    <span>{resultat[2]?.score}</span>
                    <span>/100</span>
                  </div>
                  <h2 className={`${classes.heading} ${classes.h2}`}>
                    {resultat[2]?.description[0]}
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{
                      __html: resultatWithColor[resultat[2]?.key].longText,
                    }}
                  />
                  <div className={`${classes.imgWhiteBanner} page-break-after`} style={{ marginBottom: '0px' }}>
                    <img
                      src={`${publicSvgPath}/${
                        lang !== 'FR'
                          ? getImg(resultat[2]?.key)
                          : resultatWithColor[resultat[2]?.key].img
                      }`}
                      alt=""
                    />
                  </div>
                  <h2 className={`${classes.heading} ${classes.h3}`} style={{ marginTop: 0 }}>{resultat[2]?.label}</h2>
                  <h2 className={`${classes.heading} ${classes.h5}`} style={{ marginTop: 20 }}>
                    Les conseils de carrière d'Orientaction
                  </h2>
                  <p
                    className={classes.paragraph}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[2]?.key].text1 }}
                    style={{ marginBottom: '50px' }}
                  />
                  {resultatWithColor[resultat[2]?.key].listeAccordeon.map((item: any) => (
                    <div key={item.title} style={{ marginBottom: '60px' }}>
                      <h2 className={`${classes.heading} ${classes.h6}`}>{item.title}</h2>
                      <p
                        className={classes.paragraph}
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      />
                    </div>
                  ))}

                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4 }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[2]?.key].text2 }}
                  />

                  <h2 className={`${classes.heading} ${classes.h4}`} style={{ marginTop: 120, marginBottom: '20px' }}>
                    Liste des métiers en lien avec cette valeur
                  </h2>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginBottom: '50px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[2]?.key].text3 }}
                  />
                  <ul className={classes.listUl}>
                    {concat(
                      resultatWithColor[resultat[2]?.key].listEmploi1,
                      resultatWithColor[resultat[2]?.key].listEmploi2
                    ).map((item: any) => (
                      <li className={classes.listLi} key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <p
                    className={classes.paragraph}
                    style={{ fontSize: 24, fontWeight: 700, lineHeight: 1.4, marginTop: '45px' }}
                    dangerouslySetInnerHTML={{ __html: resultatWithColor[resultat[2]?.key].text4 }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
);

ResultatPDF.displayName = 'ResultatPDF';

export default ResultatPDF;
